/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  class App {
    constructor() {
      this._init();
    }

    _init() {
      this._initUpsellSwiper();
      this._initProductInfoCarousel();
      this._initExternalLinks();
    }

    _initUpsellSwiper() {
      this.upsellSwiper = this._initSwiper(".upsell-swiper", {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: (index, className) => {
            const slides = document.querySelectorAll(
              ".upsell-swiper .swiper-slide",
            );
            const tabText = slides[index]?.dataset.tabText || "";
            return (
              `<span class="${className}">` +
              `<span class="pagination-number">${index + 1}</span>` +
              (tabText
                ? `<span class="pagination-text">${tabText}</span>`
                : "") +
              `</span>`
            );
          },
        },
      });

      this._onDesignMode(() => {
        this._destroySwiper(this.upsellSwiper);
        this._initUpsellSwiper();
      });
    }

    _initProductInfoCarousel() {
      if (!document.querySelector(".product-info-swiper")) return;

      this.productInfoSwiper = this._initSwiper(".product-info-swiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 600,
        autoHeight: false,
        allowTouchMove: true,
                rewind: true,
                        autoplay: {
                                  delay: 9000,
                                            disableOnInteraction: true,
                                                      pauseOnMouseEnter: false,
                                                              },
        on: {
          slideChange: (swiper) => this._updateActiveTabs(swiper.activeIndex),
        },
      });

      this.keyIngredientsSwiper = this._initSwiper(".key-ingredients-swiper", {
        direction: "vertical",
        slidesPerView: 4,
        spaceBetween: 10,
        grabCursor: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        navigation: {
          prevEl: ".key-ingredients-swiper__nav .swiper-button-prev",
          nextEl: ".key-ingredients-swiper__nav .swiper-button-next",
        },
      });

      this._initNavBg();
      this._initTabClicks();

      this._onDesignMode((event) => {
        if (!event.target.querySelector(".product-info-swiper")) return;
        this._destroySwiper(this.productInfoSwiper);
        this._destroySwiper(this.keyIngredientsSwiper);
        this._initProductInfoCarousel();
      });
    }

    _initSwiper(selector, config) {
      const el = document.querySelector(selector);
      if (!el) return null;
      return new Swiper(selector, config);
    }

    _destroySwiper(swiper) {
      if (swiper) swiper.destroy(true, true);
      return null;
    }

    _initNavBg() {
      const nav = document.querySelector(".carousel-nav");
      if (!nav) return;
      this.navBg = nav.querySelector(".nav-tab--bg");
      const activeTab = nav.querySelector(".nav-tab.active");
      if (this.navBg && activeTab) this._moveNavBg(activeTab);

      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const currentActive = nav.querySelector(".nav-tab.active");
          if (currentActive) this._moveNavBg(currentActive);
        }, 100);
      });
    }
    _initTabClicks() {
      document.querySelectorAll(".carousel-nav .nav-tab").forEach((tab) => {
        tab.addEventListener("click", () => {
          const slideIndex = parseInt(tab.getAttribute("data-slide"));
          if (this.productInfoSwiper)
            this.productInfoSwiper.slideTo(slideIndex)
                    this.productInfoSwiper.autoplay.stop();;
        });
      });
    }

    _moveNavBg(tab) {
      if (!this.navBg) return;
      this.navBg.style.width = `${tab.offsetWidth}px`;
      this.navBg.style.transform = `translateX(${tab.offsetLeft}px)`;
    }

    _updateActiveTabs(index) {
      document.querySelectorAll(".carousel-nav .nav-tab").forEach((tab, i) => {
        tab.classList.toggle("active", i === index);
        if (i === index) this._moveNavBg(tab);
      });
    }

    _onDesignMode(callback) {
      if (!Shopify.designMode) return;
      ["shopify:section:load", "shopify:section:reorder"].forEach((event) => {
        document.addEventListener(event, callback);
      });
    }

    _initExternalLinks() {
      document.querySelectorAll("a:not(.cookie-policy)").forEach((link) => {
        if (link.host !== window.location.hostname) {
          link.setAttribute("target", "_blank");
          link.setAttribute("rel", "noreferrer noopener");
        }
      });
    }
  }

  document.addEventListener("DOMContentLoaded", () => new App());
})();
